import { Box, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'

const Efficiency = () => {
  return (
    <Box>
      <AspectRatio
        w={{
          base: '100%',
          sm: '100%',
          md: '100%',
          lg: '100%',
          xl: '100%'
        }}
        ratio={1366 / 589}
        position="relative"
      >
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/effection-1736490374483.png"
          alt="ingradient section"
          fill
        />
      </AspectRatio>
    </Box>
  )
}

export default Efficiency
